import { get } from './requests';

export const getLandingInfo = () => {
  return get('https://us-central1-baltichome-1cd35.cloudfunctions.net/app/site/promo/get-landing-info')
}